import { render, staticRenderFns } from "./CovidList.vue?vue&type=template&id=2c071950&scoped=true&"
import script from "./CovidList.vue?vue&type=script&lang=js&"
export * from "./CovidList.vue?vue&type=script&lang=js&"
import style0 from "./CovidList.vue?vue&type=style&index=0&id=2c071950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c071950",
  null
  
)

export default component.exports